(() => {
  if (window.FourPawPercentageSavings) return;

  const update = (root) => {
    if (!root?.matches?.('[data-fp-main]')) return;
    const variantsNode = root.querySelector('[data-fp-variants]');
    const variantInput = root.querySelector('[data-fp-variant-id]');
    const savings = root.querySelector('[data-fp-save]');
    if (!variantsNode || !variantInput || !savings) return;
    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch { return; }
    const variant = variants.find((candidate) => String(candidate.id) === String(variantInput.value));
    const compare = Number(variant?.compare_at_price || 0);
    const price = Number(variant?.price || 0);
    if (compare <= price) return;
    const percent = Math.floor((compare - price) * 100 / compare);
    savings.textContent = (window.FourPawPercentageSavingsSettings?.template || '[percent]%').replace('[percent]', String(percent));
  };

  const updateAll = (root = document) => root.querySelectorAll('[data-fp-main]').forEach(update);
  const schedule = (root) => window.requestAnimationFrame(() => update(root));
  document.addEventListener('change', (event) => {
    const root = event.target.closest?.('[data-fp-main]');
    if (root) schedule(root);
  });
  document.addEventListener('DOMContentLoaded', () => updateAll(), { once: true });
  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));
  document.addEventListener('shopify:section:unload', () => {});
  document.addEventListener('shopify:block:select', (event) => updateAll(event.target));
  window.FourPawPercentageSavings = { update, updateAll };
})();
